module.exports = __webpack_public_path__ + "img/icon-5.1bb6ec1f.png";